import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { graphql } from 'react-relay';

import { hasFeature, MODULES } from '../../security';
import routeTo from '../utils/routeTo';

import { useUnauthenticated_company } from './__generated__/useUnauthenticated_company.graphql';

// eslint-disable-next-line
graphql`
  fragment useUnauthenticated_company on Company {
    features
  }
`;

export const useUnauthenticated = (company: useUnauthenticated_company) => {
  const history = useHistory();

  const redirectIfNotAllowed = () => {
    const { pathname } = document.location;

    const requiredFeatures = [MODULES.HIRING];

    if (!company) {
      return;
    }

    if (!hasFeature({ company }, requiredFeatures) && !pathname.endsWith('notFound')) {
      return history.push(routeTo('public.notFound'));
    }
  };

  useEffect(() => {
    redirectIfNotAllowed();
  });
};
